import { render, staticRenderFns } from "./setResultDialog.vue?vue&type=template&id=070129c9&"
import script from "./setResultDialog.vue?vue&type=script&lang=js&"
export * from "./setResultDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports